module.exports = __webpack_public_path__ + "media/Video 109.dcf9d2e8.mp4";